import { combineReducers } from 'redux';

import appStatusReducer from './appStatusReducer';
import conversationReducer from './conversationReducer';
import filesReducer from './fileReducer';
import folderReducer from './folderReducer';
import globalSearchReducer from './globalSearchReducer';
import indexReducer from './indexReducer';
import navDrawerReducer from './navDrawerReducer';
import promptReducer from './promptReducer';
import userReducer from './userReducer';

export default combineReducers({
  appStatus: appStatusReducer,
  indexes: indexReducer,
  conversations: conversationReducer,
  files: filesReducer,
  folders: folderReducer,
  globalSearch: globalSearchReducer,
  navDrawer: navDrawerReducer,
  prompts: promptReducer,
  users: userReducer,
});
